// @flow
import React, { useContext } from 'react'
import './styles.scss'
import { LocaleContext } from '../../contexts/locale'

type Props = {
  clickHandler: () => void
}

export function RatingExplanationButton({ clickHandler }: Props) {
  const locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')

  return (
    <button
      className='ui large basic button rating-explanation'
      onClick={clickHandler}
    >
      <i className='info circle icon' />
      {messages.button}
      <i className='right chevron icon' />
    </button>
  )
}
